import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';
import type { ContextNavDropdownItem, ContextNavItem } from '../context-nav.interfaces';
import type { SidebarListItem } from '../../sidebar-list/sidebar-list.interfaces';
import type { SidebarMenuItem, SidebarMenuChild } from '../../sidebar-menu/sidebar-menu.interfaces';
import type { SidebarInlineConfig, SidebarStaticLabel } from './context-nav.store.interfaces';

@Injectable({ providedIn: 'root' })
export class ContextNavStore {
  private readonly _items = signal<ContextNavItem[]>([]);
  readonly items = this._items.asReadonly();

  private readonly _inlineConfig = signal<SidebarInlineConfig | null>(null);
  readonly inlineConfig = this._inlineConfig.asReadonly();

  private readonly _staticLabel = signal<SidebarStaticLabel | null>(null);
  readonly staticLabel = this._staticLabel.asReadonly();

  private readonly _projectDropdown = signal<ContextNavItem | null>(null);
  readonly projectDropdown = this._projectDropdown.asReadonly();

  private readonly _sidebarMenu = signal<SidebarMenuItem[]>([]);
  readonly sidebarMenu = this._sidebarMenu.asReadonly();

  readonly itemSelected$ = new Subject<{
    contextItemId: string;
    dropdownItem: ContextNavDropdownItem;
  }>();
  readonly createClicked$ = new Subject<string>();

  readonly inlineItemSelected$ = new Subject<SidebarListItem>();
  readonly inlineCreateClicked$ = new Subject<void>();

  readonly projectSelected$ = new Subject<ContextNavDropdownItem>();
  readonly projectCreateClicked$ = new Subject<void>();

  readonly sidebarMenuItemClicked$ = new Subject<SidebarMenuItem>();
  readonly sidebarMenuChildClicked$ = new Subject<SidebarMenuChild>();

  setItems(items: ContextNavItem[]): void {
    this._items.set(items);
  }

  clearItems(): void {
    this._items.set([]);
  }

  setInlineConfig(config: SidebarInlineConfig): void {
    this._inlineConfig.set(config);
  }

  clearInlineConfig(): void {
    this._inlineConfig.set(null);
  }

  setStaticLabel(label: SidebarStaticLabel): void {
    this._staticLabel.set(label);
  }

  clearStaticLabel(): void {
    this._staticLabel.set(null);
  }

  setProjectDropdown(item: ContextNavItem): void {
    this._projectDropdown.set(item);
  }

  clearProjectDropdown(): void {
    this._projectDropdown.set(null);
  }

  setSidebarMenu(items: SidebarMenuItem[]): void {
    this._sidebarMenu.set(items);
  }

  clearSidebarMenu(): void {
    this._sidebarMenu.set([]);
  }
}
